/**
 * The consideration of health measurement
 */
export enum HealthMeasurementConsideration {
  /**
   * System was not able to provide an assessment over the values.
   */
  Undetermined = 'undetermined',

  /**
   * Values are stable and within normal limits.
   */
  Good = 'good',

  /**
   * Values may be unstable and not within normal limits.
   */
  Serious = 'serious',

  /**
   * Values are unstable and not within normal limits.
   */
  Critical = 'critical',
}
